import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../../lib/utils';

const colorVariants = cva('text-muted-foreground', {
  variants: {
    variant: {
      foreground: 'text-foreground',
      muted: 'text-muted-foreground',
      primary: 'text-primary',
      secondary: 'text-secondary',
      accent: 'text-accent',
      destructive: 'text-destructive',
    },
  },
  defaultVariants: {
    variant: 'muted',
  },
});

export interface CpuIconProps
  extends React.SVGProps<SVGSVGElement>, VariantProps<typeof colorVariants> {
  size?: number | string;
}

export const CpuIcon = React.forwardRef<SVGSVGElement, CpuIconProps>(
  function CpuIcon(
    { className, style, size, width, height, variant, ...rest },
    ref,
  ) {
    const computedWidth = width ?? size ?? 16;
    const computedHeight = height ?? size ?? 16;
    const colorClass = colorVariants({ variant });

    return (
      <svg
        ref={ref}
        className={cn('stroke-current', colorClass, className)}
        style={{ ...(style as React.CSSProperties) }}
        width={computedWidth}
        height={computedHeight}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g clipPath="url(#clip0_2354_24364)">
          <path
            d="M6.00004 1.33337V3.33337M10 1.33337V3.33337M6.00004 12.6667V14.6667M10 12.6667V14.6667M12.6667 6.00004H14.6667M12.6667 9.33337H14.6667M1.33337 6.00004H3.33337M1.33337 9.33337H3.33337M6.53337 12.6667H9.46671C10.5868 12.6667 11.1469 12.6667 11.5747 12.4487C11.951 12.257 12.257 11.951 12.4487 11.5747C12.6667 11.1469 12.6667 10.5868 12.6667 9.46671V6.53337C12.6667 5.41327 12.6667 4.85322 12.4487 4.42539C12.257 4.04907 11.951 3.74311 11.5747 3.55136C11.1469 3.33337 10.5868 3.33337 9.46671 3.33337H6.53337C5.41327 3.33337 4.85322 3.33337 4.42539 3.55136C4.04907 3.74311 3.74311 4.04907 3.55136 4.42539C3.33337 4.85322 3.33337 5.41327 3.33337 6.53337V9.46671C3.33337 10.5868 3.33337 11.1469 3.55136 11.5747C3.74311 11.951 4.04907 12.257 4.42539 12.4487C4.85322 12.6667 5.41327 12.6667 6.53337 12.6667Z"
            stroke="currentColor"
            strokeWidth={1.4}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2354_24364">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

CpuIcon.displayName = 'CpuIcon';
